import { API } from "@/lib/api";

const ORIGIN = API.replace(/\/api$/, "");
const BUCKETS = [320, 480, 640, 800, 1024, 1280, 1600];

/** Rewrites any image URL to an optimized, resized variant (WebP via /api/img, or Unsplash params). */
export function optimizeUrl(url, w = 800, q = 82) {
  if (!url || typeof url !== "string") return url;
  const bucket = BUCKETS.find((b) => b >= w) || 1600;
  const m = url.match(/\/api\/(?:files|img)\/([^?]+)/);
  if (m) {
    if (/^https?:\/\//.test(m[1])) return optimizeUrl(m[1], w, q);
    return `${ORIGIN}/api/img/${m[1]}?w=${bucket}&q=${q}`;
  }
  if (url.includes("images.unsplash.com")) {
    const u = new URL(url);
    u.searchParams.set("w", String(bucket));
    u.searchParams.set("q", String(Math.min(q, 80)));
    u.searchParams.set("auto", "format");
    u.searchParams.set("fit", "crop");
    return u.toString();
  }
  if (url.includes("images.pexels.com")) {
    const u = new URL(url);
    u.searchParams.set("auto", "compress");
    u.searchParams.set("cs", "tinysrgb");
    u.searchParams.set("w", String(bucket));
    return u.toString();
  }
  return url.startsWith("/") ? `${ORIGIN}${url}` : url;
}

/** srcSet string for responsive <img>; returns undefined when the URL cannot be resized. */
export function optimizeSrcSet(url, widths = [480, 800, 1280, 1600], q = 82) {
  if (!url || !(url.includes("/api/files/") || url.includes("/api/img/") || url.includes("images.unsplash.com"))) return undefined;
  return widths.map((w) => `${optimizeUrl(url, w, q)} ${w}w`).join(", ");
}
